























































































































import Vue from "vue";
import { Select, Option } from "element-ui";
import HttpClientFactory from "../../../services/HttpClientFactory";
import HttpClient from "../../../services/HttpClient";
import SenderAddress from "../../../types/invoiceSender/SenderAddress";

export default Vue.extend({
  name: "sender-address-form",
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
  },
  data() {
    return {
      httpClient: {} as HttpClient,
      isLoading: false as boolean,
      senderAddress: {
        addressLine: "",
        city: "",
        province: "",
        postcode: "",
      } as SenderAddress,
    };
  },
  async created() {
    this.httpClient = HttpClientFactory.getInstance();
    await this.getAddress();
  },
  methods: {
    async getAddress() {
      await this.httpClient
        .get(process.env.VUE_APP_BACKEND_ENDPOINT + "/profiles/v1/me/address")
        .then((res: any) => {
          const senderAddressData: SenderAddress = res.data;
          this.senderAddress.addressLine = senderAddressData.addressLine;
          this.senderAddress.city = senderAddressData.city;
          this.senderAddress.province = senderAddressData.province;
          this.senderAddress.postcode = senderAddressData.postcode;
        })
        .catch((e: any) => {
          const error: any = {
            text: this.$t("sender:error"),
            type: "error",
          };
          this.$notify(error);
        });
    },
    async createSendersAddress() {
      this.isLoading = true;

      await this.httpClient
        .put(
          process.env.VUE_APP_BACKEND_ENDPOINT + "/senders/v1/me",
          this.senderAddress
        )
        .then(() => {
          const success: any = {
            text: this.$t("sender:saved"),
            type: "success",
          };
          this.$notify(success);
          this.isLoading = false;
        })
        .catch((e: any) => {
          this.isLoading = false;
          const error: any = {
            text: this.$t("sender:error"),
            type: "error",
          };
          this.$notify(error);
        });
    },
  },
});
